import {SmartAdSASTypes} from "../../offer/helpers/smart_add_sas_types";
import {INTERNAL_BANNERS} from "../constants/internal_banners";

export const getInternalBanner = (adFormat: number) => {
    if (adFormat !== SmartAdSASTypes.HERO) {
        return;
    }

    const randomIndex = Math.floor(Math.random() * 2);

    return INTERNAL_BANNERS[randomIndex];
};
import {SmartAdSASTypes} from "../../offer/helpers/smart_add_sas_types";
import {INTERNAL_BANNERS} from "../constants/internal_banners";

export const getInternalBanner = (adFormat: number) => {
    if (adFormat !== SmartAdSASTypes.HERO) {
        return;
    }

    const randomIndex = Math.floor(Math.random() * 2);

    return INTERNAL_BANNERS[randomIndex];
};
